// extracted by mini-css-extract-plugin
module.exports = {"indicator":"CircleNotificationIndicator_indicator__1AxYm","indicatorSize":"CircleNotificationIndicator_indicatorSize__2S5p-"};